// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"styles_servicesContainer__2rWdl","title":"styles_title__f_pfF"};